import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const interruptTriggerEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("interrupt"),
		name: Type.Literal("trigger"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
			type: Type.Union([
				Type.Literal("webcam"),
				Type.Literal("display"),
				Type.Literal("monitor count"),
				Type.Literal("face recorder"),
				Type.Literal("speaking"),
			]),
		}),
	}),
);

const interruptResumeEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("interrupt"),
		name: Type.Literal("resume"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
			type: Type.Union([
				Type.Literal("webcam"),
				Type.Literal("display"),
				Type.Literal("monitor count"),
				Type.Literal("face recorder"),
			]),
		}),
	}),
);

export default {
	interruptTriggerEvent,
	interruptResumeEvent,
};
